import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import agentService from "@/services/agent";

export const useSearchStore = defineStore("search", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchProductsBySearch(payload) {
    loading.value = true;
    try {
      const res = await agentService.getProductsBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchCategoriesBySearch(payload) {
    loading.value = true;
    try {
      const res = await agentService.getCategoriesBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchProductsBySearch,
    fetchCategoriesBySearch,
  };
});
